import { api } from '@/api/client'

/**
 * Скачивает .xlsx с сервера (GET path с params, Bearer через axios-интерсептор)
 * и инициирует загрузку файла в браузере.
 */
export async function downloadXlsx(
  path: string,
  params: Record<string, unknown>,
  filename: string,
): Promise<void> {
  const resp = await api.get(path, { params, responseType: 'blob' })
  const url = URL.createObjectURL(resp.data as Blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
